function base64urlDecode(str) {
  let base64 = str.replace(/-/g, '+').replace(/_/g, '/');
  while (base64.length % 4) {
    base64 += '=';
  }

  const base64Decoded = atob(base64);
  const utf8Decoded = decodeURIComponent(escape(base64Decoded));

  return utf8Decoded;
}

function decodeJWT(token) {
  const [headerStr, payloadStr] = token.split('.');
  const header = JSON.parse(base64urlDecode(headerStr));
  const payload = JSON.parse(base64urlDecode(payloadStr));

  return {
    header,
    payload,
  };
}

const result = Object.freeze({
  decodeJWT,
});

export default function() {
  return result;
}
